import { APP } from 'libs/constants';
import { getEuroCountryCodeNameMap } from 'libs/geographicalRegion';
import apiCall from './apiRequest';
import endPoints from './endpoints';

const euroCountryCodeNameMap = getEuroCountryCodeNameMap();

const MUSE_TRIAL_PLANS_CA = {
  plans: [
    {
      title: 'views.museTrialPlans.planCardsWrapper.monthly.CA.title',
      planID: 'ca-muse-monthly-17-49+trial',
      currency: 'CA',
      isRecommended: false,
      isSelected: false,
      frequency: 'Monthly',
      amount: 17.49,
      tax: null
    },
    {
      title: 'views.museTrialPlans.planCardsWrapper.annual.CA.title',
      tax: null,
      planID: 'ca-muse-annual-125+trial',
      currency: 'CA',
      offer: 'views.museTrialPlans.planCardsWrapper.annual.CA.offer',
      isRecommended: true,
      isSelected: true,
      frequency: 'Annual',
      amount: 124.99
    }
  ]
};

const MUSE_TRIAL_PLANS_UK = {
  plans: [
    {
      title: 'views.museTrialPlans.planCardsWrapper.monthly.UK.title',
      planID: 'uk-muse-monthly-12+trial',
      currencySymbol: '£',
      currency: 'GB',
      isRecommended: false,
      isSelected: false,
      frequency: 'Monthly',
      amount: 11.99,
      tax: null
    },
    {
      title: 'views.museTrialPlans.planCardsWrapper.annual.UK.title',
      tax: null,
      planID: 'uk-muse-annual-87+trial',
      currency: 'GB',
      currencySymbol: '£',
      offer: 'views.museTrialPlans.planCardsWrapper.annual.UK.offer',
      isRecommended: true,
      isSelected: true,
      frequency: 'Annual',
      amount: 86.99
    }
  ]
};

const MUSE_TRIAL_PLANS_EU = {
  plans: [
    {
      title: 'views.museTrialPlans.planCardsWrapper.monthly.EU.title',
      planID: 'eu-muse-monthly-14+trial',
      currencySymbol: '€',
      currency: 'EU',
      isRecommended: false,
      isSelected: false,
      frequency: 'Monthly',
      amount: 13.99,
      tax: null
    },
    {
      title: 'views.museTrialPlans.planCardsWrapper.annual.EU.title',
      tax: null,
      planID: 'eu-muse-annual-102+trial',
      currency: 'EU',
      currencySymbol: '€',
      offer: 'views.museTrialPlans.planCardsWrapper.annual.EU.offer',
      isRecommended: true,
      isSelected: true,
      frequency: 'Annual',
      amount: 101.99
    }
  ]
};

const MUSE_TRIAL_PLANS_US = {
  plans: [
    {
      title: 'views.museTrialPlans.planCardsWrapper.monthly.US.title',
      planID: 'us-muse-monthly-13+trial',
      currency: 'US',
      isRecommended: false,
      isSelected: false,
      frequency: 'Monthly',
      amount: 12.99,
      tax: null
    },
    {
      title: 'views.museTrialPlans.planCardsWrapper.annual.US.title',
      tax: null,
      planID: 'us-muse-annual-95+trial',
      currency: 'US',
      offer: 'views.museTrialPlans.planCardsWrapper.annual.US.offer',
      isRecommended: true,
      isSelected: true,
      frequency: 'Annual',
      amount: 94.99
    }
  ]
};

const MUSE_TRIAL_PLANS_AU = {
  plans: [
    {
      title: 'views.museTrialPlans.planCardsWrapper.monthly.AU.title',
      planID: 'au-muse-monthly-21+trial',
      currency: 'AU',
      isRecommended: false,
      isSelected: false,
      frequency: 'Monthly',
      amount: 20.99,
      tax: null
    },
    {
      title: 'views.museTrialPlans.planCardsWrapper.annual.AU.title',
      tax: null,
      planID: 'au-muse-annual-160+trial',
      currency: 'AU',
      offer: 'views.museTrialPlans.planCardsWrapper.annual.AU.offer',
      isRecommended: true,
      isSelected: true,
      frequency: 'Annual',
      amount: 159.99
    }
  ]
};

const nonEurocountryPlansMap = {
  US: MUSE_TRIAL_PLANS_US,
  CA: MUSE_TRIAL_PLANS_CA,
  GB: MUSE_TRIAL_PLANS_UK,
  AU: MUSE_TRIAL_PLANS_AU
};

function getCountryPlans(countryCode) {
  let plansObj = nonEurocountryPlansMap.US;

  if (nonEurocountryPlansMap[countryCode]) {
    plansObj = nonEurocountryPlansMap[countryCode];
  } else if (euroCountryCodeNameMap[countryCode]) {
    plansObj = MUSE_TRIAL_PLANS_EU;
  }

  return plansObj;
}

export function fetchMuseTrialPlansApi({ countryCode }) {
  const plansObj = getCountryPlans(countryCode);

  return Promise.resolve(plansObj);
}

export function checkoutMuseTrialPlanApi(plan, nonTrial, locale) {
  return apiCall({
    method: 'put',
    endpoint: endPoints.planCheckout,
    payload: {
      app: APP.muse,
      plan,
      non_trial: nonTrial
    },
    query: {
      locale
    }
  });
}

export default {
  fetchMuseTrialPlansApi
};



// WEBPACK FOOTER //
// ./src/api/museTrialPlans.js